export const DefaultConnectionEvents = [
    "initialized",
    "connecting",
    "connected",
    "disconnected",
    "suspended",
    "closing",
    "closed",
    "failed",
    "update",
];
